import React, { Component } from 'react';
import { Form, Segment, Icon, Message, Button, Confirm, Modal } from 'semantic-ui-react';
import { post, get, del } from '../../util/api';
import { connect } from 'react-redux';
import { updateProfile } from '../../actions/access.actions';
import { Formik } from 'formik';
import { FormikInput, MiniContainer, DropdownInput } from '../../components/FormikInput';
import * as Yup from 'yup';
import _ from 'lodash';
import { withTranslation } from 'react-i18next';
import Page from '../../components/Page';

function customizer(objValue, srcValue) {
	return _.isUndefined(objValue) || objValue === null ? srcValue : objValue;
}

var defaults = _.partialRight(_.assignWith, customizer);
class UserPage extends Component {
	state = {
		userInfo: { icon: 'save', color: 'blue', saved: 'Save', sending: false },
		userPassword: { icon: 'save', color: 'blue', saved: 'Save', sending: false },
		newpassword: '',
		modal_open: false,
		ex_file: '',
		loading: true,
		twoFactorEnabled: false,
		twoFactorQrCode: '',
		twoFactorSecret: '',
		showQrCode: false,
		twoFactorToken: '',
		enable2FALoading: false,
		disable2FALoading: false,
		verifyToken: '',
		disablePassword: '',
		twoFactorSuccessMessage: '',
		twoFactorErrorMessage: '',
		showSuccessMessage: false,
		showErrorMessage: false,
		selectedMethod: 'totp',
		sms2FAPhone: '',
		sms2FACode: '',
		showPhoneInput: false,
		sendSmsLoading: false,
		currentMethod: null,
		showSmsCodeInput: false,
		showEnableSmsCodeInput: false,
		sessions: [],
		sessionsLoading: true,
		terminatingSession: null,
		terminatingAll: false,
	};

	componentDidMount() {
		this.getSubs();
		this.get2FAStatus();
		this.getSessions();
	}

	async generate2FA() {
		const { t } = this.props;
		try {
			this.setState({ enable2FALoading: true, twoFactorErrorMessage: '' });
			const response = await post('/auth/generate-2fa');

			if (response.data.success) {
				this.setState({
					twoFactorQrCode: response.data.data.qrCode,
					twoFactorSecret: response.data.data.secret,
					showQrCode: true,
					enable2FALoading: false,
				});
			} else {
				this.setState({
					enable2FALoading: false,
					twoFactorErrorMessage: response.data.message || t('failedGenerateQR'),
					showErrorMessage: true,
				});
			}
		} catch (error) {
			console.error('Generate 2FA error:', error);
			this.setState({
				enable2FALoading: false,
				twoFactorErrorMessage: t('failedGenerateQRRetry'),
				showErrorMessage: true,
			});
		}
	}

	async enable2FA() {
		const { t } = this.props;
		try {
			if (!this.state.twoFactorToken) return;

			this.setState({ enable2FALoading: true, twoFactorErrorMessage: '' });
			const response = await post('/auth/enable-2fa', {
				token: this.state.twoFactorToken,
				method: 'totp',
			});

			if (response.data.success) {
				this.setState({
					twoFactorEnabled: true,
					currentMethod: 'totp',
					showQrCode: false,
					twoFactorToken: '',
					enable2FALoading: false,
					twoFactorSuccessMessage: t('2faEnabledSuccess'),
					showSuccessMessage: true,
					twoFactorErrorMessage: '',
				});
			} else {
				this.setState({
					enable2FALoading: false,
					twoFactorErrorMessage: response.data.message || t('failedEnable2FA'),
					showErrorMessage: true,
				});
			}
		} catch (error) {
			console.error('Enable 2FA error:', error);
			this.setState({
				enable2FALoading: false,
				twoFactorErrorMessage: t('errorEnable2FA'),
				showErrorMessage: true,
			});
		}
	}

	async disable2FA() {
		const { t } = this.props;
		try {
			if (!this.state.verifyToken || !this.state.disablePassword) return;

			this.setState({ disable2FALoading: true, twoFactorErrorMessage: '' });
			const response = await post('/auth/disable-2fa', {
				token: this.state.verifyToken,
				password: this.state.disablePassword,
			});

			if (response.data.success) {
				this.setState({
					twoFactorEnabled: false,
					currentMethod: null,
					verifyToken: '',
					disablePassword: '',
					disable2FALoading: false,
					showSmsCodeInput: false,
					sms2FAPhone: '',
					twoFactorSuccessMessage: t('2faDisabledSuccess'),
					showSuccessMessage: true,
					twoFactorErrorMessage: '',
				});
			} else {
				this.setState({
					disable2FALoading: false,
					twoFactorErrorMessage: response.data.message || t('failedDisable2FA'),
					showErrorMessage: true,
				});
			}
		} catch (error) {
			console.error('Disable 2FA error:', error);
			this.setState({
				disable2FALoading: false,
				twoFactorErrorMessage: t('errorDisable2FA'),
				showErrorMessage: true,
			});
		}
	}

	async setupSms2FA() {
		const { t } = this.props;
		try {
			this.setState({ sendSmsLoading: true, twoFactorErrorMessage: '' });
			const response = await post('/auth/setup-sms-2fa', {
				phone: this.state.sms2FAPhone,
			});

			if (response.data.success) {
				this.setState({
					sendSmsLoading: false,
					showEnableSmsCodeInput: true,
					twoFactorSuccessMessage: t('smsSentSuccess'),
					showSuccessMessage: true,
				});
			} else {
				this.setState({
					sendSmsLoading: false,
					twoFactorErrorMessage: response.data.message || t('failedSendSMS'),
					showErrorMessage: true,
				});
			}
		} catch (error) {
			this.setState({
				sendSmsLoading: false,
				twoFactorErrorMessage: t('failedSendSMSRetry'),
				showErrorMessage: true,
			});
		}
	}

	async enableSms2FA() {
		const { t } = this.props;
		try {
			this.setState({ enable2FALoading: true, twoFactorErrorMessage: '' });
			const response = await post('/auth/enable-sms-2fa', {
				code: this.state.sms2FACode,
			});

			if (response.data.success) {
				this.setState({
					twoFactorEnabled: true,
					currentMethod: 'sms',
					showPhoneInput: false,
					sms2FACode: '',
					enable2FALoading: false,
					twoFactorSuccessMessage: t('sms2faEnabledSuccess'),
					showSuccessMessage: true,
				});
			} else {
				this.setState({
					enable2FALoading: false,
					twoFactorErrorMessage: response.data.message || t('invalidSMSCode'),
					showErrorMessage: true,
				});
			}
		} catch (error) {
			this.setState({
				enable2FALoading: false,
				twoFactorErrorMessage: t('verificationFailed'),
				showErrorMessage: true,
			});
		}
	}

	async sendDisableSmsCode() {
		const { t } = this.props;
		try {
			this.setState({ sendSmsLoading: true, twoFactorErrorMessage: '' });
			const response = await post('/auth/send-disable-sms-code', {
				phone: this.state.sms2FAPhone,
				password: this.state.disablePassword,
			});

			if (response.data.success) {
				this.setState({
					sendSmsLoading: false,
					showSmsCodeInput: true,
					twoFactorSuccessMessage: t('smsSentSuccess'),
					showSuccessMessage: true,
				});
			} else {
				this.setState({
					sendSmsLoading: false,
					twoFactorErrorMessage: response.data.message || t('phoneNotMatch'),
					showErrorMessage: true,
				});
			}
		} catch (error) {
			this.setState({
				sendSmsLoading: false,
				twoFactorErrorMessage: t('failedSendSMSRetry'),
				showErrorMessage: true,
			});
		}
	}

	async getSessions() {
		try {
			const response = await get('/auth/sessions');
			if (response.success) {
				this.setState({ sessions: response.data, sessionsLoading: false });
			} else {
				this.setState({ sessionsLoading: false });
			}
		} catch (error) {
			this.setState({ sessionsLoading: false });
		}
	}

	async terminateSession(sid) {
		this.setState({ terminatingSession: sid });
		try {
			await del(`/auth/sessions/${sid}`);
			this.setState((prev) => ({
				sessions: prev.sessions.filter((s) => s.sid !== sid),
				terminatingSession: null,
			}));
		} catch (error) {
			this.setState({ terminatingSession: null });
		}
	}

	async terminateOtherSessions() {
		this.setState({ terminatingAll: true });
		const others = this.state.sessions.filter((s) => !s.isCurrent);
		await Promise.all(others.map((s) => del(`/auth/sessions/${s.sid}`).catch(() => {})));
		this.setState((prev) => ({
			sessions: prev.sessions.filter((s) => s.isCurrent),
			terminatingAll: false,
		}));
	}

	async get2FAStatus() {
		try {
			const response = await get('/auth/2fa-status');
			if (response.success) {
				this.setState({
					twoFactorEnabled: response.data.enabled,
					currentMethod: response.data.method,
				});
			}
		} catch (error) {
			console.error('2FA status error:', error);
		}
	}

	async getSubs() {
		await post('/live/product/getsubscription', { pid: this.props.product.id }).then((data) => {
			let subs = data && data.data && data.data.subscriptions;
			let isActiveSub = _.filter(subs, (it) => it.data && it.data.status && it.data.status === 'active');
			this.setState({ subs, isActiveSub, loading: false });
		});
	}

	handleChange = (e, { name, value }) => this.setState({ [name]: value });

	changePlatform(value) {
		post('/live/product/setPanel', { panel: value }).then((response) => window.location.reload());
	}

	openModal(value) {
		const { product } = this.props;
		let { isActiveSub } = this.state;
		if (isActiveSub && isActiveSub.length) {
			this.setState({ subsModal: true });
			return;
		}
		let platform = product && product.settings && product.settings.panel;
		if (platform !== value) this.setState({ modal_open: true, value });
	}

	handleSubmit = (values) => {
		const { t } = this.props;
		if (this.state.userInfo.sending) return;
		this.setState({ userInfo: { sending: true } });
		this.props.updateUser(values);
		this.setState({
			userInfo: { sending: false, errormessage: '', saved: t('saved'), color: 'teal', icon: 'check' },
		});
		clearTimeout(this.timeout);
		this.timeout = setTimeout(() => {
			this.setState({ userInfo: { icon: 'save', color: 'blue', saved: t('save') } });
		}, 2000);
		this.postData(values);
	};

	handleSubmitPassword = (values) => {
		const { t } = this.props;
		if (this.state.userPassword.sending) return;
		this.setState({ userPassword: { sending: true } });
		this.props.updateUser(values);
		this.postPassword(values);
		if (this.state.passwordError) {
			this.setState({
				userPassword: { sending: false, errormessage: '', saved: t('unSaved'), color: 'red', icon: 'x' },
			});
		} else {
			this.setState({
				userPassword: { sending: false, errormessage: '', saved: t('saved'), color: 'teal', icon: 'check' },
			});
		}

		clearTimeout(this.timeout);
		this.timeout = setTimeout(() => {
			this.setState({ userPassword: { icon: 'save', color: 'blue', saved: t('save') } });
		}, 2000);
	};

	postData(values) {
		let body = {
			name: values.name,
			phone: values.phone,
			company: values.company,
			email: values.email,
			agent: true,
		};
		if (!values.__isAgent) {
			body.extra = _.merge(values.extra, {
				ecommerce: values.ecommerce,
				domain: values.domain,
				isContacts: values.isContacts,
			});
		}
		post('/auth/updateInfo', body);
	}

	postPassword(values) {
		post('/auth/updatePassword', {
			newpassword: values.newpassword,
		}).then((data) => {
			this.setState({ passwordErrorMessage: data.data.message, passwordError: data.data.success });
		});
	}

	postVerifyMail(values) {
		post('/mailer/verify', { email: values.email }).then((data) => {
			if (data.data.success) {
				this.setState({ verifyMessage: 'New verify link was sent your email.' });
			} else {
				this.setState({ verifyMessage: 'Error...' });
			}
		});
	}

	render() {
		const { t, host, user, product } = this.props;
		let { modal_open, value, subsModal, loading } = this.state;
		let platform = product && product.settings && product.settings.panel;
		const initials = defaults({}, this.props.user, this.props.user.extra, {
			name: '',
			company: '',
			phone: '',
			newpassword: '',
			confirmpassword: '',
			isContacts: false,
		});
		const options = [
			{
				text: t('yes'),
				value: 'yes',
			},
			{
				text: t('no'),
				value: 'no',
			},
		];
		const options_2 = [
			{
				text: t('openTrue'),
				value: true,
			},
			{
				text: t('closeFalse'),
				value: false,
			},
		];
		let roleAgent = user && user.role && user.role === 'agent';
		if (loading) return <Page.Loader></Page.Loader>;
		return (
			<Segment>
				<MiniContainer>
					{!roleAgent && (
						<div style={{ marginBottom: '20px' }}>
							<h3>
								<Icon name="at" />
								{t('platform')}
							</h3>
							<Button.Group>
								<Button color="blue" basic={platform === 'dialogtab' ? false : true} onClick={() => this.openModal('dialogtab')}>
									DialogTab Panel
								</Button>
							</Button.Group>
						</div>
					)}

					<Confirm
						open={modal_open}
						content={t('areYouSureChangePlatform')}
						onCancel={() => this.setState({ modal_open: false })}
						onConfirm={() => this.changePlatform(value)}
						cancelButton={t('no')}
						confirmButton={t('yes')}
					></Confirm>
					<Modal open={subsModal} closeIcon content={t('youUnsubscribeSubs')} onClose={() => this.setState({ subsModal: false })}></Modal>
					<h3>
						<Icon name="user" />
						{t('personalInformation')}
					</h3>
					{host === 'app.dialogtab.com' && !this.props.user.verified ? (
						<Message error>
							<span>{t('accountNotVerified')}</span>
							<Button size="mini" primary style={{ marginLeft: '10px' }} onClick={() => this.postVerifyMail({ email: this.props.user.email })}>
								{t('sendMail')}
							</Button>
						</Message>
					) : (
						''
					)}
					<Segment>
						<Formik
							initialValues={initials}
							onSubmit={this.handleSubmit}
							validationSchema={Yup.object().shape({
								name: Yup.string().required(t('nameisRequired')),
							})}
						>
							{(props) => {
								const { values, handleChange, handleBlur, handleSubmit } = props;

								return (
									<Form onSubmit={handleSubmit}>
										<FormikInput
											id="name"
											label={t('name')}
											name="name"
											icon="user"
											iconPosition="left"
											placeholder={t('userPlaceholder', { query: t('name') })}
											type="text"
											value={values.name}
											onChange={handleChange}
											onBlur={handleBlur}
										/>
										<FormikInput
											id="company"
											label={t('companyName')}
											icon="building"
											name="company"
											placeholder={t('userPlaceholder', { query: t('company') })}
											iconPosition="left"
											type="text"
											value={values.company}
											onChange={handleChange}
											onBlur={handleBlur}
										/>
										<FormikInput
											id="email"
											label={t('email')}
											name="email"
											icon="at"
											iconPosition="left"
											placeholder={t('userPlaceholder', { query: t('email') })}
											type="text"
											value={values.email}
											onChange={handleChange}
											onBlur={handleBlur}
											readOnly
										/>
										<FormikInput
											id="phone"
											label={t('phone')}
											iconPosition="left"
											name="phone"
											icon="phone"
											placeholder={t('userPlaceholder', { query: t('phone') })}
											type="phone"
											value={values.phone}
											onChange={handleChange}
											onBlur={handleBlur}
										/>
										{!values.__isAgent ? (
											<div>
												<FormikInput
													id="domain"
													label="Domain"
													iconPosition="left"
													name="domain"
													icon="at"
													placeholder={t('enterDomain')}
													type="domain"
													value={values.domain}
													onChange={handleChange}
													onBlur={handleBlur}
												></FormikInput>
												<Form.Field
													required
													style={{
														display: 'block',
														margin: '0 0 .28571429rem 0',
														color: 'rgba(0,0,0,.87)',
														fontSize: '.92857143em',
														fontWeight: '700',
														textTransform: 'none',
													}}
												>
													{t('areYouEcommerce')}
												</Form.Field>
												<DropdownInput name="ecommerce" list={options} placeholder={t('select')} />
											</div>
										) : null}
										<Form.Field
											required
											style={{
												display: 'block',
												margin: '0 0 .28571429rem 0',
												color: 'rgba(0,0,0,.87)',
												fontSize: '.92857143em',
												fontWeight: '700',
												textTransform: 'none',
											}}
										>
											{t('contacts')}
										</Form.Field>
										<DropdownInput name="isContacts" list={options_2} placeholder={t('contacts')} />
										<Form.Button
											fluid
											style={{ marginTop: '15px' }}
											icon={this.state.userInfo.icon}
											type="submit"
											color={this.state.userInfo.color}
											content={this.state.userInfo.saved}
											loading={this.state.userInfo.sending}
										/>
									</Form>
								);
							}}
						</Formik>
					</Segment>
					<h3 style={{ marginTop: '5rem' }}>
						<Icon name="lock" />
						{t('password')}
					</h3>
					<Segment>
						<Formik
							initialValues={initials}
							onSubmit={this.handleSubmitPassword}
							validationSchema={Yup.object().shape({
								newpassword: Yup.string()
									.required('Password is required!')
									.matches(
										/^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,}$/,
										'Password must be min 8, at least one uppercase, lowercase and special character.'
									),
								confirmpassword: Yup.string().oneOf([Yup.ref('newpassword'), null], t('passwordValidationMatch')),
							})}
						>
							{(props) => {
								const { handleChange, handleBlur, handleSubmit } = props;
								return (
									<Form onSubmit={handleSubmit}>
										<FormikInput
											label={t('newPassword')}
											icon="key"
											iconPosition="left"
											name="newpassword"
											type="password"
											placeholder={t('enterNewPassword')}
											id="newpassword"
											onChange={handleChange}
											onBlur={handleBlur}
										/>
										<FormikInput
											label={t('confirmPassword')}
											icon="key"
											iconPosition="left"
											name="confirmpassword"
											type="password"
											placeholder={t('enterNewPasswordAgain')}
											onChange={handleChange}
											onBlur={handleBlur}
										/>
										<Form.Button
											fluid
											icon={this.state.userPassword.icon}
											type="submit"
											color={this.state.userPassword.color}
											content={this.state.userPassword.saved}
											loading={this.state.userPassword.sending}
										/>
									</Form>
								);
							}}
						</Formik>
					</Segment>
					<h3 style={{ marginTop: '5rem' }}>
						<Icon name="shield alternate" />
						{t('twoFactorAuth') || 'Two-Factor Authentication'}
					</h3>
					<Segment>
						{this.state.showSuccessMessage && this.state.twoFactorSuccessMessage && (
							<Message positive style={{ marginBottom: '20px' }}>
								<Icon name="check circle" />
								{this.state.twoFactorSuccessMessage}
							</Message>
						)}

						{this.state.showErrorMessage && this.state.twoFactorErrorMessage && (
							<Message negative style={{ marginBottom: '20px' }}>
								<Icon name="exclamation triangle" />
								{this.state.twoFactorErrorMessage}
							</Message>
						)}

						{!this.state.twoFactorEnabled ? (
							<div>
								<p>{t('2faDescription') || 'Secure your account with two-factor authentication.'}</p>

								{!this.state.showQrCode && !this.state.showPhoneInput && (
									<div>
										<Form.Field>
											<label>{t('select2FAMethod') || 'Select Authentication Method'}</label>
										</Form.Field>
										<Button.Group>
											<Button
												color={this.state.selectedMethod === 'totp' ? 'green' : 'grey'}
												onClick={() => this.setState({ selectedMethod: 'totp' })}
											>
												<Icon name="mobile alternate" />
												{t('authenticatorApp') || 'Authenticator App'}
											</Button>
											<Button
												color={this.state.selectedMethod === 'sms' ? 'green' : 'grey'}
												onClick={() => this.setState({ selectedMethod: 'sms' })}
											>
												<Icon name="comment" />
												{t('smsVerification') || 'SMS Verification'}
											</Button>
										</Button.Group>

										<div style={{ marginTop: '20px' }}>
											{this.state.selectedMethod === 'totp' ? (
												<Button color="green" loading={this.state.enable2FALoading} onClick={() => this.generate2FA()}>
													<Icon name="shield alternate" />
													{t('setupAuthenticator') || 'Setup Authenticator'}
												</Button>
											) : (
												<Button color="green" onClick={() => this.setState({ showPhoneInput: true })}>
													<Icon name="phone" />
													{t('setupSMS') || 'Setup SMS'}
												</Button>
											)}
										</div>
									</div>
								)}

								{this.state.showQrCode && (
									<div>
										<Message info>
											<p>{t('scanQrCode') || 'Scan this QR code with your authenticator app (Google Authenticator, Authy, etc.):'}</p>
										</Message>

										<div style={{ textAlign: 'center', marginBottom: '20px' }}>
											<img src={this.state.twoFactorQrCode} alt="2FA QR Code" />
										</div>

										<Message>
											<p>
												<strong>{t('manualEntry') || 'Manual Entry Key'}:</strong>
											</p>
											<code style={{ wordBreak: 'break-all' }}>{this.state.twoFactorSecret}</code>
										</Message>

										<Form>
											<Form.Field>
												<label>{t('verificationCode') || 'Enter 6-digit code from your app'}</label>
												<Form.Input
													placeholder="123456"
													value={this.state.twoFactorToken}
													onChange={(e) => this.setState({ twoFactorToken: e.target.value })}
													maxLength={6}
												/>
											</Form.Field>
											<Button
												color="green"
												loading={this.state.enable2FALoading}
												onClick={() => this.enable2FA()}
												disabled={this.state.twoFactorToken.length !== 6}
											>
												{t('verify') || 'Verify & Enable'}
											</Button>
											<Button basic onClick={() => this.setState({ showQrCode: false, twoFactorToken: '' })}>
												{t('cancel') || 'Cancel'}
											</Button>
										</Form>
									</div>
								)}

								{this.state.showPhoneInput && (
									<div>
										<Message info>
											<p>{t('enterPhoneForSMS') || 'Enter your phone number to receive verification codes via SMS.'}</p>
										</Message>

										<Form>
											<Form.Field>
												<label>{t('phoneNumber') || 'Phone Number'}</label>
												<Form.Input
													placeholder="+90 555 123 4567"
													value={this.state.sms2FAPhone}
													onChange={(e) => this.setState({ sms2FAPhone: e.target.value })}
													icon="phone"
													iconPosition="left"
												/>
											</Form.Field>

											{this.state.showEnableSmsCodeInput && (
												<Form.Field>
													<label>{t('smsVerificationCode') || 'SMS Verification Code'}</label>
													<Form.Input
														placeholder="123456"
														value={this.state.sms2FACode}
														onChange={(e) => this.setState({ sms2FACode: e.target.value })}
														maxLength={6}
													/>
												</Form.Field>
											)}

											{!this.state.showEnableSmsCodeInput ? (
												<Button
													color="green"
													loading={this.state.sendSmsLoading}
													onClick={() => this.setupSms2FA()}
													disabled={!this.state.sms2FAPhone}
												>
													<Icon name="send" />
													{t('sendSMSCode') || 'Send SMS Code'}
												</Button>
											) : (
												<Button
													color="green"
													loading={this.state.enable2FALoading}
													onClick={() => this.enableSms2FA()}
													disabled={this.state.sms2FACode.length !== 6}
												>
													{t('verify') || 'Verify & Enable'}
												</Button>
											)}

											<Button
												basic
												onClick={() =>
													this.setState({
														showPhoneInput: false,
														sms2FAPhone: '',
														sms2FACode: '',
														showEnableSmsCodeInput: false,
													})
												}
											>
												{t('cancel') || 'Cancel'}
											</Button>
										</Form>
									</div>
								)}
							</div>
						) : (
							<div>
								<Message positive>
									<Icon name="check circle" />
									{this.state.currentMethod === 'totp'
										? t('authenticatorEnabled') || 'Two-factor authentication via Authenticator App is enabled.'
										: t('smsEnabled') || 'Two-factor authentication via SMS is enabled.'}
								</Message>

								<Form>
									<Form.Field>
										<label>{t('currentPassword') || 'Current Password'}</label>
										<Form.Input
											type="password"
											value={this.state.disablePassword}
											onChange={(e) => this.setState({ disablePassword: e.target.value })}
											placeholder={t('enterCurrentPassword') || 'Enter your current password'}
										/>
									</Form.Field>

									{this.state.currentMethod === 'sms' && (
										<Form.Field>
											<label>{t('phoneNumber') || 'Phone Number'}</label>
											<Form.Input
												value={this.state.sms2FAPhone}
												onChange={(e) => this.setState({ sms2FAPhone: e.target.value })}
												placeholder="+90 555 123 4567"
												icon="phone"
												iconPosition="left"
											/>
										</Form.Field>
									)}

									{this.state.currentMethod === 'sms' && !this.state.showSmsCodeInput ? (
										<>
											<Button
												color="blue"
												loading={this.state.sendSmsLoading}
												onClick={() => this.sendDisableSmsCode()}
												disabled={!this.state.disablePassword || !this.state.sms2FAPhone}
											>
												<Icon name="send" />
												{t('sendSMSCode') || 'Send SMS Code'}
											</Button>
											<Button
												color="red"
												loading={this.state.disable2FALoading}
												onClick={() => this.disable2FA()}
												disabled={this.state.verifyToken.length !== 6 || !this.state.disablePassword}
											>
												<Icon name="remove" />
												{t('disable2FA') || 'Disable 2FA'}
											</Button>
										</>
									) : (
										<>
											<Form.Field>
												<label>{t('verificationCode') || '2FA Verification Code'}</label>
												<Form.Input
													placeholder="123456"
													value={this.state.verifyToken}
													onChange={(e) => this.setState({ verifyToken: e.target.value })}
													maxLength={6}
												/>
											</Form.Field>
											<Button
												color="red"
												loading={this.state.disable2FALoading}
												onClick={() => this.disable2FA()}
												disabled={this.state.verifyToken.length !== 6 || !this.state.disablePassword}
											>
												<Icon name="remove" />
												{t('disable2FA') || 'Disable 2FA'}
											</Button>
										</>
									)}
								</Form>
							</div>
						)}
					</Segment>
						<h3 style={{ marginTop: '5rem' }}>
							<Icon name="computer" />
							{t('connectedDevices')}
						</h3>
						<Segment>
							{this.state.sessionsLoading ? (
								<Page.Loader />
							) : (
								<div>
									{this.state.sessions.filter((s) => !s.isCurrent).length > 0 && (
										<Button
											size="small"
											color="red"
											basic
											loading={this.state.terminatingAll}
											onClick={() => this.terminateOtherSessions()}
											style={{ marginBottom: '1rem' }}
										>
											<Icon name="sign out" />
											{t('terminateOtherSessions')}
										</Button>
									)}
									{this.state.sessions.length === 0 ? (
										<p style={{ color: '#999' }}>{t('noOtherSessions')}</p>
									) : (
										this.state.sessions.map((session) => (
											<Segment key={session.sid} style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
												<Icon
													name={session.device === 'mobile' ? 'mobile alternate' : session.device === 'tablet' ? 'tablet alternate' : 'desktop'}
													size="large"
													color={session.isCurrent ? 'blue' : 'grey'}
												/>
												<div style={{ flex: 1 }}>
													<div style={{ fontWeight: 'bold' }}>
														{session.browser || t('unknownBrowser')}
														{session.isCurrent && (
															<span style={{ marginLeft: '8px', color: '#2185d0', fontSize: '0.8em', fontWeight: 'normal' }}>
																({t('thisDevice')})
															</span>
														)}
													</div>
													<div style={{ color: '#666', fontSize: '0.9em' }}>
														{session.os || t('unknownOS')}
													</div>
													<div style={{ color: '#999', fontSize: '0.85em', marginTop: '2px' }}>
														{session.ip && <span>{session.ip} · </span>}
														{session.loginAt && <span>{new Date(session.loginAt).toLocaleString()}</span>}
													</div>
												</div>
												{!session.isCurrent && (
													<Button
														size="small"
														color="red"
														basic
														loading={this.state.terminatingSession === session.sid}
														onClick={() => this.terminateSession(session.sid)}
													>
														{t('terminateSession')}
													</Button>
												)}
											</Segment>
										))
									)}
								</div>
							)}
						</Segment>
					</MiniContainer>
			</Segment>
		);
	}
}

export default connect(
	(state) => ({ user: state.access.user.loggedUserObj, product: state.product.live }),
	(dispatch) => ({ updateUser: (user) => dispatch(updateProfile(user)) })
)(withTranslation()(UserPage));
